import { ICreateProvisaoRecursoUseCase } from "../../../presentation/useCases/create/create_provisao_recurso_servicos_use_case";
import { IQualidadeRepository } from "../../repositories/qualidade_repository";

// CreateProvisaoRecursoUseCase

export class CreateProvisaoRecursoUseCase implements ICreateProvisaoRecursoUseCase {
  constructor(private readonly repository: IQualidadeRepository) {}

  async createProvisaoRecurso(
      Recurso: string, Observacao: string | null, DataPrevistaDe: Date | null, DataPrevistaAte: Date | null, DataRealizadaDe: Date | null, DataRealizadaAte: Date | null, ValorPrevisto: number | null, ValorDesembolsado: number | null,
): Promise<void> {
    
    await this.repository.createProvisaoRecurso(
    Recurso, Observacao, DataPrevistaDe, DataPrevistaAte, DataRealizadaDe, DataRealizadaAte, ValorPrevisto, ValorDesembolsado,
    );
  }
}